module.exports = __webpack_public_path__ + "static/media/topmenu_406logo.c776e9fd.png";